import { render, staticRenderFns } from "./PermissionIndexView.vue?vue&type=template&id=abb93c44"
import script from "./PermissionIndexView.vue?vue&type=script&lang=js"
export * from "./PermissionIndexView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports